/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompositeComment } from '../models/CompositeComment';
import type { SurveyJobCompanyJobMappingComment } from '../models/SurveyJobCompanyJobMappingComment';
import type { SurveyJobCompanyJobMappingCommentsInfo } from '../models/SurveyJobCompanyJobMappingCommentsInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class JobMappingCommentService {

    /**
     * Get Survey Job Company Job Mapping Comment List
     * @returns any Success
     * @throws ApiError
     */
    public static getSurveyJobCompanyJobMappingCommentList({
        mappingId,
        limit,
        offset,
    }: {
        /**
         * Survey Job Company Job Mapping Id
         */
        mappingId: number,
        limit?: number,
        offset?: number,
    }): CancelablePromise<{
        rows: Array<SurveyJobCompanyJobMappingComment>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/mapping/job/{mappingId}/comment',
            path: {
                'mappingId': mappingId,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Add Survey Job Company Job Mapping Comment
     * @returns SurveyJobCompanyJobMappingComment Success
     * @throws ApiError
     */
    public static addSurveyJobCompanyJobMappingComment({
        mappingId,
        requestBody,
    }: {
        /**
         * Survey Job Company Job Mapping Id
         */
        mappingId: number,
        requestBody: {
            commentText: string;
        },
    }): CancelablePromise<SurveyJobCompanyJobMappingComment> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mapping/job/{mappingId}/comment',
            path: {
                'mappingId': mappingId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * View Survey Job Company Job Mapping Comment
     * @returns SurveyJobCompanyJobMappingComment Success
     * @throws ApiError
     */
    public static viewSurveyJobCompanyJobMappingComment({
        mappingId,
        commentId,
    }: {
        /**
         * Survey Job Company Job Mapping Id
         */
        mappingId: number,
        /**
         * Comment id
         */
        commentId: number,
    }): CancelablePromise<SurveyJobCompanyJobMappingComment> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/mapping/job/{mappingId}/comment/{commentId}',
            path: {
                'mappingId': mappingId,
                'commentId': commentId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update Survey Job Company Job Mapping Comment
     * @returns CompositeComment Success
     * @throws ApiError
     */
    public static updateSurveyJobCompanyJobMappingComment({
        mappingId,
        commentId,
        requestBody,
    }: {
        /**
         * Survey Job Company Job Mapping Id
         */
        mappingId: number,
        /**
         * Comment id
         */
        commentId: number,
        requestBody: {
            commentText: string;
        },
    }): CancelablePromise<CompositeComment> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/mapping/job/{mappingId}/comment/{commentId}',
            path: {
                'mappingId': mappingId,
                'commentId': commentId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete Survey Job Company Job Mapping Comment
     * @returns any Success
     * @throws ApiError
     */
    public static deleteSurveyJobCompanyJobMappingComment({
        mappingId,
        commentId,
    }: {
        /**
         * Survey Job Company Job Mapping Id
         */
        mappingId: number,
        /**
         * Comment id
         */
        commentId: number,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/mapping/job/{mappingId}/comment/{commentId}',
            path: {
                'mappingId': mappingId,
                'commentId': commentId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Survey Job Company Job Mapping Comments Info
     * @returns any Success
     * @throws ApiError
     */
    public static getSurveyJobCompanyJobMappingCommentsInfo({
        jobMappingIds,
    }: {
        /**
         * Ids of job mapping
         */
        jobMappingIds: Array<number>,
    }): CancelablePromise<{
        commentsInfo: Array<SurveyJobCompanyJobMappingCommentsInfo>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/mapping/job/commentsInfo',
            query: {
                'jobMappingIds': jobMappingIds,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
